// extracted by mini-css-extract-plugin
export default {"root":"Tabs_root__K3Fjs","tabs":"Tabs_tabs__mElEu utils_line-height-fixed__VfrIp","tab":"Tabs_tab__kE2yZ"};